import { TimerBarFillerStyled } from './TimeBar.styled'
import { TimeBarProps } from '../types'

const TimerBar = ({ isActive, duration, pause }: TimeBarProps) => {
  return (
    <div className='round-time-bar'>
      {isActive && <TimerBarFillerStyled duration={duration} pause={pause} className='time-bar-fill' />}
    </div>
  )
}

export default TimerBar
